import axiosBase from 'axios'
import Constants from '../../constants'

const Axios = {
  setup: function (serviceAreaId, token) {
    const s = Constants.DOCOMO_SERVICE_AREAS.find((s) => s.id == serviceAreaId)
    const a = axiosBase.create({
      baseURL: s.url,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      responseType: 'json'
    })

    return a
  }
}

export default Axios
